var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper"},[_c('div',{staticClass:"content"},[(_vm.pulldown)?_c('div',[_c('div',{staticClass:"top-tip"},[_c('div',{},[_vm._v(_vm._s(_vm.dragTip.text))])])]):_vm._e(),_vm._t("default")],2),_vm._t("AZ"),_vm._t("search")],2)}
var staticRenderFns = []

export { render, staticRenderFns }